import React, { useState } from "react";
import tracks from "../public/interactive-assets/doppler/youtube-tracks.json";

// Only these two bundled resources get a YouTube player. Imported HTML keeps
// its existing sandbox; the external link lives in the parent document.
export function dopplerYouTubeTrack(url: string | undefined) {
  if (url === "/interactive-assets/doppler/audio-player.html?track=f1") return tracks.f1;
  if (url === "/interactive-assets/doppler/audio-player.html?track=trumpet") return tracks.trumpet;
  return undefined;
}

export function DopplerYouTube({ track }: { track: typeof tracks.f1 }) {
  const [showPlayer, setShowPlayer] = useState(false);
  return (
    <div className="studio-doppler-video">
      <div className="studio-doppler-video-actions" onClick={(event) => event.stopPropagation()}>
        <a href={`https://www.youtube.com/watch?v=${track.videoId}`} target="_blank" rel="noopener noreferrer">
          Ouvrir sur YouTube ↗
        </a>
        <button type="button" onClick={() => setShowPlayer(!showPlayer)} aria-expanded={showPlayer}>
          {showPlayer ? "Masquer le lecteur" : "Afficher le lecteur intégré"}
        </button>
      </div>
      {showPlayer && (
        <iframe
          title={track.title}
          src={`https://www.youtube-nocookie.com/embed/${track.videoId}`}
          allow="encrypted-media; picture-in-picture; fullscreen"
          allowFullScreen
          referrerPolicy="strict-origin-when-cross-origin"
        />
      )}
      <p className="studio-caption">Si la lecture intégrée est indisponible, ouvrez la vidéo sur YouTube.</p>
    </div>
  );
}
